export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";